import get from "lodash/get";
// import reverse from "lodash/reverse";

function persianDateFilter(georgian_date) {
  if (georgian_date) {
    return new Date(georgian_date).toLocaleDateString("fa");
  }
  return "";
}

function getObjectValueByPath(obj, filed) {
  if (filed.computed) {
    return filed.computed(obj);
  }
  let value = get(obj, filed.value, "");
  if (filed.filter) {
    return filed.filter === "persianDateFilter" ?
      persianDateFilter(value) :
      filed.filter(value);
  }
  return value;
}

function xlsExport(data, filename = "download",branch_name ="Money Service Provider") {
  window.XlsxPopulate.fromBlankAsync() // Load a new blank workbook
    .then(workbook => {
      const sheet1 = workbook.sheet("Sheet1");
      for (let i = 2; i < 16; i++) {
        sheet1.column(i).style({
          fontSize: 10,
          bold: true,
          fontFamily: "B Nazanin",
          verticalAlignment: "center",
          horizontalAlignment: "center"
        });
      }
      let items = data.items;
      let recordsLength = items.length;
      // let headers = reverse(data.headers);
      let headers = data.headers;
      let headersLen = headers.length + 2;

      //start row, start column, end row,end column
      sheet1
        .range(2, 2, 2, headersLen)
        .merged(true)
        .value(branch_name)
        .style({
          fontSize: 11
        });
      sheet1
        .range(3, 2, 3, headersLen)
        .merged(true)
        .value("")
        .style({
          fontSize: 11
        });
      sheet1
        .range(4, 2, 4, headersLen)
        .merged(true)
        .value("")
        .style({
          fontSize: 11
        });
      sheet1
        .range(5, 2, 5, headersLen)
        .merged(true)
        .value(data.title)
        .style({
          fontSize: 11
        });
      sheet1.range(6, 2, 6, headersLen).merged(true);

      for (let c = 2; c < headersLen; c++) {
        sheet1
          .row(7)
          .cell(c)
          .value(headers[c - 2].text);
      }
      sheet1
        .row(7)
        .cell(headersLen)
        .value("No");
      for (let i = 0; i < recordsLength; i++) {
        for (let c = 2; c < headersLen; c++) {
          sheet1
            .row(i + 8)
            .cell(c)
            .value(getObjectValueByPath(items[i], headers[c - 2]) || " ");
        }
        sheet1
          .row(i + 8)
          .cell(headersLen)
          .value(i + 1);
      }
      sheet1.range(7, 2, recordsLength + 7, headersLen).style({
        border: true
      });

      // exporting to file
      workbook.outputAsync().then(function (blob) {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // If IE, you must uses a different method.
          window.navigator.msSaveOrOpenBlob(blob, filename + ".xlsx");
        } else {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          a.download = filename + ".xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
      });
    });
}

export default xlsExport;